import {IonButton, IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonLabel, IonList, IonMenuButton, IonNote, IonPage, IonRefresher, IonRefresherContent, IonRouterLink, IonRow, IonSegment, IonSegmentButton, IonTitle, IonToolbar, RefresherEventDetail, useIonRouter, useIonViewWillEnter, useIonViewWillLeave} from '@ionic/react';
import {capitalize, productInfo} from '../utils';
import {useStoreState} from 'pullstate';


import {fetch_Pg_6_1, fetch_Pg_6_3, Pg_6_1_Store, Pg_6_3_Store, push_pg_6_3} from "../store/Pg_6_Store";
import {getPageData, getQuotes} from "../store/Selectors";
import {Fragment, useEffect, useRef, useState} from "react";
import {QuoteItem} from "../components/QuoteItem";
import {ContractItem} from "../components/ContractItem";
import {fetch_pg_1_2} from "../store/Pg_1_Store";
import {checkmarkOutline, chevronDownCircleOutline} from "ionicons/icons";
import {TokenStackItem} from "../components/TokenStackItem";
import {useAppUtil, useSideMenuOptions, useSideMenuUpdate} from "../components/sideMenu/SideMenuProvider";
import {tab1SideMenu} from "../components/sideMenu/PageSideMenus";
import {PageHeader} from "./PageHeader";
import {Modal} from "./Modal";
import CustomPage from "./CustomPage";
import {TokenEnwItem} from "../components/TokenEnwItem";
import {TokenEnwEntrustListItem} from "../components/TokenEnwEntrustListItem";
import {useParams} from "react-router";
import {useLoginFields} from "./Pg_A_1";
import {useFormInput, validateForm} from "../_/useForms";
import indexBy from "underscore/modules/indexBy";
import styles_TokenItem from "../components/CheckableTokenItem.module.scss";
import {fetch_pg_0_3} from "../store/Pg_0_Store";
import {handleFetchCommonErrors, navAwayToPg_6_1, navAwayToPg_A_1} from "./Utils";
import CustomField from "../components/CustomField";
import {Pg_B_1_Store} from "../store/Pg_B_Store";
import {Pg_C_4_Store, push_pg_C_1} from "../store/Pg_C_Store";
import {CheckableTokenEnwItem} from "../components/CheckableTokenEnwItem";
import ClassNames from "../components/ClassNames";
import {UserPostCommentFavorStore, UserTokenEnwStore} from "../store/Common_Store";
import {usePageDataLoader} from "../_/usePageDataLoader";
import styles_Pg_C_1 from "./Pg_C_1.module.scss";
import styles_Common from "./Common.module.scss";
import update from 'immutability-helper'
import {ColorPicker, useColor} from "react-color-palette";
import "react-color-palette/css";
import {DragableTokenEnwItem} from "../components/DragableTokenEnwItem";
import {Sortable} from "../components/Sortable";

import {
    AnimateLayoutChanges,
    defaultAnimateLayoutChanges,
    horizontalListSortingStrategy,
} from '@dnd-kit/sortable';
import {restrictToHorizontalAxis} from '@dnd-kit/modifiers';
import {List} from "../components/drag/List";

export const useRegisterFields = (Item_撥放清單: any) => {
    return [
        {
            id: "p1",
            label: "TokenEnwId組",
            required: false,
            input: {
                props: {
                    type: "text",
                    placeholder: "TokenEnwId組",
                },
                state: useFormInput(Item_撥放清單.TokenEnwId組)
            },
            checkedList: useRef<any[]>([]),
        },
        {
            id: "p2",
            label: "撥放清單名稱",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "撥放清單名稱",
                },
                state: useFormInput(Item_撥放清單.撥放清單名稱)
            }
        },
        {
            id: "p3",
            label: "背景色",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "背景色",
                },
                state: useFormInput(Item_撥放清單.背景色)
            }
        },
        {
            id: "p4",
            label: "播放間隔秒",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "播放間隔秒",
                },
                state: useFormInput(Item_撥放清單.播放間隔秒)
            }
        },
        {
            id: "p5",
            label: "撥放清單Id",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "",
                },
                state: useFormInput(Item_撥放清單.撥放清單Id)
            }
        },
    ];
}

const ColorPad = ({initialValue, setter}) => {
    const [color, setColor] = useColor(initialValue);

    return <ColorPicker hideAlpha={true} hideInput={["rgb", "hsv"]} color={color} onChange={(v) => {
        setColor(v);
    }} onChangeComplete={(v) => {
        setter(v.hex);
    }}/>;
};

const InnerForm = ({Item_撥放清單, List_TokenEnw, router, pageId}) => {
    const [, setForceRender] = useState<number>(0);
    const forceRender = (triggerLoad = false) => {
        setForceRender(s => s + 1);
    }

    const userTokenEnwStore = useStoreState(UserTokenEnwStore, getPageData);

    const [showColorPicker, setShowColorPicker] = useState(false);

    const fields = useRegisterFields(Item_撥放清單);
    let keyedFields = indexBy(fields, 'id');
    const [errors, setErrors] = useState(false);

    let keyed_List_TokenEnw = indexBy(List_TokenEnw, 'TokenEnwId');
    let savedCheckedList = Item_撥放清單.TokenEnwId組
        ?.split(",")
        ?.map(item => item.trim())
        ?.filter(Boolean) ?? [];


    const push_register = async () => {
        //if (agreementRef.current.value =)
        const errors = validateForm(fields);
        setErrors(errors);

        if (keyedFields.p1.checkedList.current.length === 0) {
            alert('最少要選取一個 [顯示的3D模組] ');
            return;
        }

        if (errors.length >= 1) {
            alert('欄位沒寫完成，請檢視 (欄位右側有註解缺甚麼)');
            return;
        }

        // if (!agreementRef?.current?.checked) {
        //     alert('需要勾選同意會員條款');
        //     return;
        // }

        if (!errors.length) {
            //  Submit your form here
            const p2 = fields && (keyedFields.p2 as any).input.state.value;
            const p3 = fields && (keyedFields.p3 as any).input.state.value;
            const p4 = fields && (keyedFields.p4 as any).input.state.value;
            const p5 = fields && (keyedFields.p5 as any).input.state.value;

            //const password = fields && (fields.filter(e => e.id === 'password')[0] as any).input.state.value;
            //const password = fields && (fields.filter(e => e.id === 'password')[0] as any).input.state.value;


            try {
                if (await push_pg_6_3({
                    p1: keyedFields.p1.checkedList.current.join(','),
                    p2,
                    p3,
                    p4,
                    p5,
                })) {
                    alert('修改完成');
                    navAwayToPg_6_1(router);
                }
            } catch (err) {

            }
        }
    }

    let currentCheckedList = keyedFields.p1.checkedList.current;

    const baseStyles: any = {
        // height: 150,
        // width: 150,
    };

    const props: any = {
        Container: (props: any) => <List horizontal {...props} />,
        itemCount: 100,
        getItemStyles: () => baseStyles,
        strategy: horizontalListSortingStrategy,
    };

    return <Fragment>
        <IonGrid>
            <IonRow>
                <IonCol>
                    新增撥放清單
                </IonCol>
            </IonRow>
        </IonGrid>


        <IonGrid>
            <IonRow>
                <IonCol>
                    1. 打勾想要顯示的3D模組
                </IonCol>
            </IonRow>
        </IonGrid>
        <IonGrid>
            <IonRow>
                <IonCol>
                    <div></div>
                    <div className={ClassNames(styles_TokenItem.coverImageContainer, pageId)}>
                        <List horizontal {...props}>
                            {List_TokenEnw.map((item, index) => {
                                return <Fragment key={item.TokenEnwId}>
                                    <CheckableTokenEnwItem parentForceRender={forceRender} Item_TokenEnwItem={item} field={keyedFields.p1} defaultChecked={savedCheckedList.filter(r => r == item.TokenEnwId).length > 0}/>
                                </Fragment>
                            })}
                        </List>
                    </div>
                </IonCol>
            </IonRow>
        </IonGrid>

        <IonGrid>
            <IonRow>
                <IonCol>
                    2. 填寫必要資料
                </IonCol>
            </IonRow>
        </IonGrid>
        <IonRow>
            <IonCol>
                <CustomField field={keyedFields.p2} errors={errors}/>
            </IonCol>
        </IonRow>
        <IonRow>
            <IonCol>
                <CustomField innerClassName={styles_Common.fitWrapper} field={keyedFields.p3} errors={errors} alternateRightZoneFunc={(setter) => <>
                    <div>
                        <IonButton fill={"solid"} onClick={() => setShowColorPicker(!showColorPicker)} className={styles_Pg_C_1.sideRight}>
                            {!showColorPicker ? "打開" : "關閉"}選色彩
                        </IonButton>
                    </div>
                </>
                }/>
            </IonCol>
        </IonRow>
        <IonRow>
            <IonCol>
                <CustomField field={keyedFields.p3} mainZoneFunc={(setter) => <>
                    {showColorPicker &&
                        <div>
                            <ColorPad initialValue={(keyedFields.p3 as any).input.state.value} setter={setter}/>
                        </div>
                    }
                </>
                }/>
            </IonCol>
        </IonRow>
        <IonRow>
            <IonCol>
                <CustomField innerClassName={styles_Common.fitWrapper} field={keyedFields.p4} errors={errors} alternateRightZoneFunc={(setter) => <>
                    <div>
                        <IonButton fill={"solid"} onClick={() => setter(60)} className={styles_Pg_C_1.sideRight}>
                            60秒
                        </IonButton>
                        <IonButton fill={"solid"} onClick={() => setter(120)} className={styles_Pg_C_1.sideRight}>
                            120秒
                        </IonButton>
                        <IonButton fill={"solid"} onClick={() => setter(600)} className={styles_Pg_C_1.sideRight}>
                            600秒
                        </IonButton>
                    </div>
                </>
                }/>
            </IonCol>
        </IonRow>

        <IonGrid>
            <IonRow>
                <IonCol>
                    3. 預覽結果，並調整順序
                </IonCol>
            </IonRow>
        </IonGrid>
        <IonGrid>
            <IonRow>
                <IonCol>
                    <div></div>
                    <div className={ClassNames(styles_TokenItem.coverImageContainer, pageId)}>
                        <List>
                        {currentCheckedList?.[0] &&
                            <Sortable {...props} handle={true} useDragOverlay={true} renderItem={
                                (o) => {
                                    let item = keyed_List_TokenEnw[o.value];
                                    return <DragableTokenEnwItem Item_TokenEnwItem={item}/>
                                }
                            } items={currentCheckedList} itemsSetter={(newArray)=>{
                                keyedFields.p1.checkedList.current = newArray;
                            }}
                            />
                        }

                        {/*{currentCheckedList.map((itemId, index) => {*/}
                        {/*    return <Fragment key={itemId}>*/}
                        {/*        <Sortable {...props} handle renderItem={*/}
                        {/*            (k) => {*/}
                        {/*                let item = keyed_List_TokenEnw[itemId];*/}
                        {/*                return <DragableTokenEnwItem Item_TokenEnwItem={item}/>*/}
                        {/*            }*/}
                        {/*        }/>*/}
                        {/*    </Fragment>*/}
                        {/*})}*/}
                        </List>
                    </div>

                </IonCol>
            </IonRow>
        </IonGrid>

        <IonRow className="ion-margin-top ion-padding-top">
            <IonCol size="12">
                <IonButton className="custom-button" expand="block" onClick={() => push_register()}>確定修改</IonButton>
            </IonCol>
        </IonRow>

        {/*<IonRouterLink routerLink={`/5_1`}>*/}
        {/*    <IonButton fill={"solid"}>*/}
        {/*        <IonIcon icon={checkmarkOutline}/>*/}
        {/*        &nbsp;全部委託 跳到5_1*/}
        {/*    </IonButton>*/}
        {/*</IonRouterLink>*/}

        {/*<IonRouterLink routerLink={`/5_5`}>*/}
        {/*    <IonButton fill={"solid"}>*/}
        {/*        <IonIcon icon={checkmarkOutline}/>*/}
        {/*        &nbsp;我的委託 跳到5_5*/}
        {/*    </IonButton>*/}
        {/*</IonRouterLink>*/}

        {/*<IonRouterLink routerLink={`/5_7`}>*/}
        {/*    <IonButton fill={"solid"}>*/}
        {/*        <IonIcon icon={checkmarkOutline}/>*/}
        {/*        &nbsp;標記委託 跳到5_7*/}
        {/*    </IonButton>*/}
        {/*</IonRouterLink>*/}

        {/*<IonGrid className="ion-padding">*/}
        {/*    /!*<IonRow className={ styles.searchContainer }>*!/*/}
        {/*    /!*    <IonCol size="12">*!/*/}
        {/*    /!*        <IonSearchbar animated placeholder="Search for a product" />*!/*/}
        {/*    /!*    </IonCol>*!/*/}
        {/*    /!*</IonRow>*!/*/}


        {/*    /!*click={() => handleShowModal(item)}*!/*/}
        {/*    <div className={styles_TokenItem.coverImageContainer}>*/}
        {/*        {List_Token.map((item, index) => {*/}
        {/*            return <Fragment key={item.TokenId}>*/}
        {/*                <TokenStackItem Item_Token={item}/>*/}
        {/*            </Fragment>*/}
        {/*        })}*/}
        {/*    </div>*/}
        {/*</IonGrid>*/}
    </Fragment>;
}
const Pg_6_3 = (props) => {
    const pageRef = useRef();
    const pageName = "Pg_6_3";
    const pageId = "Pg_6_3";
    const {sideMenuOptions} = props;
    const setSideMenu: any = useSideMenuUpdate();
    const sideMenu: any = useSideMenuOptions();

    const router = useIonRouter();

    const {param_playlistId}: any = useParams();

    const [playlistId, setPlaylistId] = useState<any>(param_playlistId);

    useEffect(() => {
        setSideMenu({options: sideMenuOptions, side: "start", pageName: pageId});
    }, []);

    //#region Data Loading

    // useIonViewWillEnter(() => {
    //     console.warn('useIonViewWillEnter 6_3')
    // });
    //
    // useIonViewWillLeave(() => {
    //     console.warn('useIonViewWillLeave 6_3')
    // });

    // useEffect(() => {
    //     console.warn('useEffect @window.location.toString()')
    // }, [window.location.toString()]);


    const pgData = useStoreState(Pg_6_3_Store, getPageData);

    let {pageDataLoaderCtrl} = usePageDataLoader('/tabs/6_3/[^/]+', Pg_6_3_Store, async () => {
        let errorObj = await fetch_Pg_6_3({
            p1: param_playlistId,
        });
        handleFetchCommonErrors(router, errorObj);
    })

    let reload = async (event?: CustomEvent<RefresherEventDetail>) => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        pageDataLoaderCtrl?.loadingFunc()
        event?.detail?.complete();
    }

    useEffect(() => {
        if (pgData?.reload == true) {
            Pg_6_3_Store.replace({});
            reload();
        }
    }, [pgData]);

    let hasLoaded = pgData?.Root ?? false;
    //hasLoaded = true;
    const Item_撥放清單 = hasLoaded ? pgData.Root.Item_撥放清單 : undefined;
    const List_TokenEnw = hasLoaded ? pgData.Root.List_TokenEnw : undefined;

    //let RegionLockMessage = hasLoaded ? pgData.Root.RegionLockMessage : undefined;
    let RegionLockMessage = null;
    //#endregion


    //#region +Event

    //#region click_全部委託
    const click_全部委託 = async () => {
        const navToPg_5_1 = () => {
            router.push("/tabs/5_1", "forward", "push");
        }
        navToPg_5_1();
        return false;
    }
    //#endregion

    //#region click_我的委託
    const click_我的委託 = async () => {
        const navToPg_5_5 = () => {
            router.push("/tabs/5_5", "forward", "push");
        }
        navToPg_5_5();
        return false;
    }
    //#endregion

    //#region click_標記委託
    const click_標記委託 = async () => {
        const navToPg_5_7 = () => {
            router.push("/tabs/5_7", "forward", "push");
        }
        navToPg_5_7();
        return false;
    }


    //#endregion

    //#endregion

    return (
        <IonPage id={pageId}>
            <CustomPage name={pageId} sideMenu={false} sideMenuPosition="start" backButton={false}>
                {/*<IonRefresher slot="fixed" onIonRefresh={reload}>*/}
                {/*    <IonRefresherContent*/}
                {/*        pullingIcon={chevronDownCircleOutline}*/}
                {/*        pullingText="Pull to refresh"*/}
                {/*        refreshingSpinner="circles"*/}
                {/*        refreshingText="Refreshing...">*/}
                {/*    </IonRefresherContent>*/}
                {/*</IonRefresher>*/}

                {hasLoaded && <Fragment>
                    {RegionLockMessage ?
                        <>
                            <IonGrid>
                                <IonRow>
                                    <IonCol className="ion-justify-content-center ion-text-center w100 ion-padding">
                                        {RegionLockMessage}
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </> : <>
                            <InnerForm key={Item_撥放清單.撥放清單Id} Item_撥放清單={Item_撥放清單} router={router} pageId={pageId} List_TokenEnw={List_TokenEnw}/>
                        </>}
                </Fragment>}
            </CustomPage>
        </IonPage>
    );
};

export default Pg_6_3;
